import { ChangeDetectorRef, DestroyRef, inject, Pipe, PipeTransform } from '@angular/core';
import { BehaviorSubject, switchMap, timer } from 'rxjs';

const INTERVALS = {
  day: 86400,
  hour: 3600,
  minute: 60,
  month: 2592000,
  second: 1,
  week: 604800,
  year: 31536000,
};

@Pipe({
  name: 'avsTimeAgo',
  pure: false,
})
export class TimeAgoPipe implements PipeTransform {
  private cdr = inject(ChangeDetectorRef);
  private destroyRef = inject(DestroyRef);

  private value$ = new BehaviorSubject<string | Date | null | undefined>(undefined);
  private lastResult = '—';

  constructor() {
    const sub = this.value$.pipe(
      switchMap((value) => timer(0, 60000).pipe(
        switchMap(() => [this.format(value)]),
      )),
    ).subscribe((result) => {
      this.lastResult = result;
      this.cdr.markForCheck();
    });

    this.destroyRef.onDestroy(() => sub.unsubscribe());
  }

  transform(value: string | Date | null | undefined): string {
    if (value !== this.value$.value) {
      this.value$.next(value);
    }

    return this.lastResult;
  }

  private format(value: string | Date | null | undefined): string {
    if (value) {
      const seconds = Math.floor((+new Date() - +new Date(value)) / 1000);

      if (seconds < 29)
        return 'Just now';

      let counter;

      for (const key in INTERVALS) {
        counter = Math.floor(seconds / INTERVALS[key as keyof typeof INTERVALS]);
        if (counter > 0)
          if (counter === 1) {
            return counter + ' ' + key + ' ago';
          } else {
            return counter + ' ' + key + 's ago';
          }
      }
    }

    return '—';
  }
}
